module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isPc()) ? _c('fzg-home-pc', {
    attrs: {
      "fz-team-list": _vm.fz_team_list,
      "fz-deal-list": _vm.fz_deal_list,
      "fz-article-list": _vm.fz_article_list
    }
  }) : _c('fzg-home-mobile', {
    attrs: {
      "fz-team-list": _vm.fz_team_list,
      "fz-deal-list": _vm.fz_deal_list,
      "fz-article-list": _vm.fz_article_list
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3327859a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/FzgHome.vue
// module id = 219
// module chunks = 0